/**
 * Custom scripts for the Dawn theme
 */


// Initialize scripts when DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  // Add your initialization code here
  initHoverToClick();
  initSmoothScroll();
  
  // Utility function to make dropdown menus open on hover
  function initHoverToClick() {
    // Target all details in header menus
    const detailsElements = document.querySelectorAll('details[id^="Details-HeaderMenu-"], details[id^="Details-HeaderSubMenu-"]');
    const headerWrapper = document.querySelector('.header-wrapper');
    
    detailsElements.forEach(details => {
      let hoverTimeout;
      let hoverIntentTimeout;
      
      // Open on mouseenter with delay to verify hover intent
      details.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        clearTimeout(hoverIntentTimeout);
        
        // Add hovered class to header-wrapper
        if (headerWrapper) headerWrapper.classList.add('hovered');
        
        // Delay to confirm hover intent before proceeding
        hoverIntentTimeout = setTimeout(() => {
          // Only trigger if not already open
          if (!details.hasAttribute('open')) {
            const summary = details.querySelector('summary');
            if (summary) {
              details.setAttribute('open', '');
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        }, 100); // 300ms delay to confirm hover intent
      });
      
      // Cancel hover intent if mouse leaves before timeout
      details.addEventListener('mouseleave', () => {
        clearTimeout(hoverIntentTimeout);
        
        // Remove hovered class from header-wrapper
        if (headerWrapper) headerWrapper.classList.remove('hovered');
        
        hoverTimeout = setTimeout(() => {
          if (details.hasAttribute('open')) {
            const summary = details.querySelector('summary');
            if (summary) {
              details.removeAttribute('open');
              summary.setAttribute('aria-expanded', 'false');
            }
          }
        }, 100); // Delay in ms before closing
      });
      
      // Handle nested menus
      const nestedDetails = details.querySelectorAll('details');
      nestedDetails.forEach(nestedDetail => {
        // Clear parent's timeout when entering nested menu
        nestedDetail.addEventListener('mouseenter', (e) => {
          e.stopPropagation();
          clearTimeout(hoverTimeout);
          
          // Keep hovered class on header-wrapper for nested menus
          if (headerWrapper) headerWrapper.classList.add('hovered');
        });
        
        // For submenu items, we need to prevent them from closing immediately
        nestedDetail.addEventListener('mouseleave', (e) => {
          e.stopPropagation(); // Prevent triggering parent's mouseleave
        });
      });
      
      // Prevent clicks from toggling the menu (let hover handle it instead)
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          return false;
        });
      }
      
      // Handle submenu list items
      const submenuItems = details.querySelectorAll('.header__submenu li');
      submenuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimeout); // Prevent menu from closing when hovering over submenu items
          
          // Keep hovered class on header-wrapper for submenu items
          if (headerWrapper) headerWrapper.classList.add('hovered');
        });
      });
    });
  }

  // Function to enable smooth scrolling for anchor links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        
        // Skip if it's just "#" or empty
        if (targetId === '#' || !targetId) return;
        
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          e.preventDefault();
          
          // Get sticky header height to offset scrolling
          const stickyHeader = document.querySelector('.header-wrapper');
          const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
          
          // Calculate the final scroll position with the header offset
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight;
          
          // Smooth scroll to element with offset
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          
          // Update URL without reload, for better UX
          history.pushState(null, null, targetId);
        }
      });
    });
  }

});

